export const PF = 'add-edit-suppliers';
